import Vue from 'vue'
import LogoMsg from "./LogoMsg.vue";

const LogoMsgConstructor = Vue.extend(LogoMsg)

export const logoMsg = (text, t,  options = {}) => {
  const instance = new LogoMsgConstructor({
    data: {
      text,
      ...options,
    }
  })

  document.body.appendChild(instance.$mount().$el)

  setTimeout(() => {
    if (instance.$el && instance.$el.parentNode === document.body) {
      document.body.removeChild(instance.$el)
    }
  }, t || 3000)

  return instance
}
